<template>
  <div style="witdh:100%; height:100%;">
      <WindowFrame
        class="ma-0 pa-0"
        :component="'trello'"
        ref="windowframe_trello"
        :input_args="input_args_trello"
      />
  </div>
</template>

<script>
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";

export default {
  name: "PanoramicaNew",
  components: {
    WindowFrame
  },
  props: {},
  data() {
    return {
        // Variabili d'appoggio
        input_args_trello: {
          landing_page: "/amministrazione"
        },

        // Modal
        // Array
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {

  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
.admintools{
  width:100%;
  position: relative;
  user-select: none;
}
.admintools p{
  white-space: nowrap;
  text-overflow: ellipsis;
  width:100%;
  overflow: hidden;
  font-weight: 500;
  font-size: 18px;
  color:black;
}

</style>